import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { FillHeightContainer, EmptyState } from '@steelbuy/ui-primitive';
import { isRequestQuotePath } from '@steelbuy/util';
import { RoutePath } from '../../router/Routes';
import { FOOTER_HEIGHT } from '../app-layout/app-footer/AppFooter';

export const MyRFQsEmptyState = () => {
    const { t } = useTranslation(['translation', 'uiDomain']);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const isRequestQuote = isRequestQuotePath(pathname);

    return (
        <FillHeightContainer
            className="my-rfqs-list__empty-state-container"
            extraPadding={FOOTER_HEIGHT}
            minHeight={160}
        >
            <EmptyState
                caption={t('uiDomain:commonList.noListCaption')}
                description={t('application.myRFQ.noResultsDescription')}
                button={{
                    label: t('application.myRFQ.noListingsCallToAction'),
                    onClick: () =>
                        navigate(isRequestQuote ? RoutePath.CREATE_REQUEST_QUOTE : RoutePath.CREATE_RFQ_WIZARD),
                }}
            />
        </FillHeightContainer>
    );
};
